import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { DateService } from '../services/date.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { MatTabGroup } from '@angular/material/tabs';
import { NgForm } from '@angular/forms';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import * as globalUrls from '../services/globalVariables';

declare var $: any;
@Component({
  selector: 'app-collaborateur',
  templateUrl: './collaborateur.component.html',
  styleUrls: ['./collaborateur.component.scss'],
})
export class CollaborateurComponent implements OnInit {
  //************ */ajouter***********  typeTrs=1
  //************ */modifier**********  typeTrs=2
  //************ */consulter*********  typeTrs=3

  // ***********Perso_Type***************
  // Perso_Type = 0 collaborateur
  // Perso_Type = 1 condidat
  // Perso_Type = 2 apperant
  constructor(
    public dateService: DateService,
    public dialog: MatDialog,
    public http: HttpClient,
    public router: Router,
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public elRef: ElementRef
  ) {}
  //@ViewChild//
  @ViewChild('formInformation', { static: false }) formInformation: NgForm;
  @ViewChild('formModaliteFormation', { static: false })
  formModaliteFormation: NgForm;
  @ViewChild('formSituationProfessionnelle', { static: false })
  formSituationProfessionnelle: NgForm;
  @ViewChild(GooglePlaceDirective, { static: true })
  placesRef: GooglePlaceDirective;
  @ViewChild(MatTabGroup, { static: true }) tabGroupe: MatTabGroup;
  @ViewChild('frmModaliterFormation', { static: false }) frmModaliterFormation;
  @ViewChild('listeCompetences', { static: false }) listeCompetences;
  @ViewChild('listeModaliterFormationComponen', { static: false })
  listeModaliterFormationComponen: AvtListesComponent;
  @ViewChild('listeFinanceurComponen', { static: false })
  listeFinanceurComponen: AvtListesComponent;
  @ViewChild('listeMachineComponen', { static: false })
  listeMachineComponen: AvtListesComponent;
  @ViewChild('listeReservationMachineComponen', { static: false })
  listeReservationMachineComponen: AvtListesComponent;
  //@ViewChild//
  //@ViewChild(MatTabGroup,{static:true}) tabGroupe :MatTabGroup;
  listeTypePerso = [];
  datasourceFinanceur = [];
  listeModaliterApprenant = []; //{text:"alternance",value:"0"},{text:"présentielle",value:"1"},{text:"e-learning",value:"2"}
  listeFinencementApprenant = [];
  listeCursusApprenant = [];
  listeCursus = [];
  show = true;
  perso_Type: string = '0';
  typeCollText = '';
  test = false;
  disabled = false;
  postUrl = '...';
  url = globalUrls.urlPerso;
  urlCompetence = globalUrls.urlListCompetence;
  typeColIsSalarier: boolean = true;
  selected = '2';
  showDoc: boolean = false;
  testAvatar: boolean = true;
  componentForm = this.generalService.componentForm;
  compt = 12;
  exist: boolean = true;
  disabledSituationProfessionnelle: boolean = true;
  disabledEchanges: boolean = true;
  disabledMatetiels: boolean = true;
  disabledModaliteFormation: boolean = true;
  activerDocument = true;
  showPrestataire = false;
  haveImage = false;
  index;
  oldIndex = 0;
  nationalite;
  pays;
  myFormData: FormData; //populated by ngfFormData directive
  httpEvent: HttpEvent<any>;
  typeTrs;
  param_code;
  dataCompetence;
  ds;
  imageName: string = '';
  imageSrc: string = '';
  imageType: string = '';
  imageCollaborateur;
  numberFileToSave: number = 0;
  datasourceModaliterFormation = [];
  modaliterFormation = 'Modalités de la formation';
  listBtnMachine = [
    {
      name: 'accorder',
      class: 'colorBlue',
      text: 'Accordés',
      disabled: false,
      icon: 'add',
    },
  ];
  listBtnReservationMachine = [
    {
      name: 'reserver',
      class: 'colorBlue',
      text: 'Réserver',
      disabled: false,
      icon: 'add',
    },
  ];
  columnMachine = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Machine_Code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'type',
        Lg_Code: '',
        TableRD_Des: 'Type',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'numSerie',
        Lg_Code: '',
        TableRD_Des: 'Série',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'detaile',
        Lg_Code: '',
        TableRD_Des: 'Détaile',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  //columnsModaliterFormation
  columnsModaliterFormation = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Perso_Nature',
        Lg_Code: '',
        TableRD_Des: 'Nature',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TypeApp',
        Lg_Code: '',
        TableRD_Des: 'Type apprenant',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'TypeContrat',
        Lg_Code: '',
        TableRD_Des: 'Type contrat',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Mododalite',
        Lg_Code: '',
        TableRD_Des: this.modaliterFormation,
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Cursus',
        Lg_Code: '',
        TableRD_Des: 'Cursus',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  //"avtCursusFinance_Tva":null,"avtCursusFinance_ModeFacturation":null,"avtCursusFinance_DelaiReglement"
  columnsFinanceur = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Tiers_code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Tiers_NomPublic',
        Lg_Code: '',
        TableRD_Des: 'Financeurs',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 3,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        numColonneToShow: 1,
        numColonneToReturn: 0,
        recherche: 'client',
        param: '',
        style: { width: '150px' },
        placeholder: '',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtCursusFinance_NbrHeure',
        Lg_Code: '',
        TableRD_Des: 'Nbr.Heure',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtCursusFinance_ModePaiement',
        Lg_Code: '',
        TableRD_Des: 'Mode de paiement',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtCursusFinance_Tva',
        Lg_Code: '',
        TableRD_Des: 'Tva',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtCursusFinance_ModeFacturation',
        Lg_Code: '',
        TableRD_Des: 'Mode de facturation',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtCursusFinance_DelaiReglement',
        Lg_Code: '',
        TableRD_Des: 'Délai reglement',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
    ],
  };
  listBtnModaliterFormation = [
    {
      name: 'ajouterModaliterFormation',
      class: 'colorGreen',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'modifierModaliterFormation',
      class: 'colorBlue',
      text: 'Modifier',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'SupprimerModaliterFormation',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];

  showCompetenceColl: boolean = false;
  listeContrats = [];
  listeTypeContratBrut;
  contrats = [];
  statuts = [];
  listeStatuts = [];
  listeRemunerations = [];
  remunerations = [];
  temps = [];
  listeTemps = [];
  uniteDurer = [];
  data;
  userFile;
  showDateFinContrat: boolean = true;
  dsCompetance = [];
  docCollBrut;
  showTabEchange: boolean = false;
  showTabAlert: boolean = false;
  avatarSrc: string = '../../assets/avatar.png';
  classCardInformation: string = 'cardInformation';
  data_Apprenant;
  apprenantNotMineur: boolean = false;
  showEditerContrat: boolean = false;
  listeTypeFontion = [];
  listeTypeCandidat = [];
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = JSON.parse(JSON.stringify(this.generalService.editorConfig)) ;
  listeContratsIsLoadet = false;
  listeTempsIsLoadet = false;
  listeStatutsIsLoadet = false;
  listeRemunerationsIsLoated = false;
  listeTypePersoIsLoadet = false;
  listeTypeContratBrutIsLoadet = false;
  showListeModaliterFormation: boolean = true;
  steApprenant: string;
  initCursusApprenant;
  cursusApprenant;
  listeModaliterApprenantIsLoadet: boolean = false;
  listeCursusIsLoadet: boolean = false;
  listeNature = [
    { value: 0, text: 'Inscrit' },
    { value: 1, text: 'Prospect' },
  ];
  actionFrmModaliterFormation: string = '';
  Tiers_codeFinanceur: string;
  avtCursusFinance;
  listeTva;
  listeTvaIsLoadet = false;
  listeModePaiement;
  listeModePaiementIsLoadet = false;
  listeModeFacturation;
  listeModeFacturationIsLoadet = false;
  listeDelaiReglement;
  listeDelaiReglementIsLoadet = false;
  situationPro = 'Situation professionnelle';
  informations = 'Informations';
  document = 'Documents';
  disabledBtnCpmpte: boolean = false;
  showCompte: boolean = false;
  user = {
    username: '',
    email: '',
    password: '',
    confirmpassword: '',
    tiers: '',
    menu: '',
  };
  btn = { text: 'Ajouter', icon: 'add' };
  ngOnInit() {
    this.cursusApprenant = {};
    this.data = {};
    this.data_Apprenant = {};
    this.avtCursusFinance = {};
    this.nationalite = this.generalService.nationalitePays;
    this.pays = this.generalService.nationalitePays;
    this.readParamUrl();
  }

  blurSteApprenant(event) {
    this.data.Tiers_code = event;
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'reserver': {
        this.reserverMachine();
        break;
      }
      case 'accorder': {
        this.accorderMachine();
        break;
      }
    }
  }
  reserverMachine() {
    var windows = this.generalService.popupCenter('/w/avt/reservation/machine');
    windows.onbeforeunload = () => {
      this.getListeReservationMachine();
    };
  }
  accorderMachine() {
    var windows = this.generalService.popupCenter('/w/avt/liste/machine/1');
    windows.onbeforeunload = () => {
      this.getListeMachine();
    };
  }
  async actionBtnModaliter(event) {
    switch (event.name) {
      case 'ajouterModaliterFormation': {
        this.actionFrmModaliterFormation = 'ajouterModaliterFormation';
        this.getFrmModaliterFormation(true);
        break;
      }
      case 'modifierModaliterFormation': {
        if (this.listeModaliterFormationComponen.row != undefined) {
          if (
            this.listeModeFacturationIsLoadet &&
            this.listeTvaIsLoadet &&
            this.listeModePaiementIsLoadet &&
            this.listeDelaiReglementIsLoadet
          ) {
            this.actionFrmModaliterFormation = 'modifierModaliterFormation';
            this.getFrmModaliterFormation(true);
          } else
            this.generalService.dialogSuccess(
              'Veuillez patienter pendant le chargement total des données',
              false
            );
        } else
          this.generalService.dialogSuccess(
            'Veuillez sélectionner une ligne',
            false
          );
        break;
      }
      case 'SupprimerModaliterFormation': {
        this.SupprimerModaliterFormation();
        break;
      }
    }
  }
  SupprimerModaliterFormation() {
    if (this.listeModaliterFormationComponen.row != undefined) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(
            this.listeModaliterFormationComponen.row.avtCursusApprenant_Id,
            'avtCursusApprenant'
          );
          if (deleteFn != null) {
            this.exist = false;
            deleteFn.subscribe(
              (data) => {
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.getListeCursusApprenant();
                this.exist = true;
              },
              (error) => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
              }
            );
          }
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  async enregistrerModaliterFormation(form) {
    if (this.initCursusApprenant != undefined) {
      if (form.valid) {
        this.exist = false;
        this.generalService.enregisterTable(this.initCursusApprenant).subscribe(
          (data) => {
            if (data.code != '')
              this.initCursusApprenant.avtCursusApprenant_Id = data.code;
            this.getListeCursusApprenant();
            this.getFrmModaliterFormation(false);
            this.generalService.dialogSuccess('Enregistré', true);
          },
          () => {
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
      }
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  fermerModaliterFormation() {
    this.dialog.closeAll();
  }
  getListeFinanceur() {
    this.generalService
      .rechercheTable(
        this.generalService.url +
          'avtCursusFinance&param=' +
          this.cursusApprenant.avtCursusApprenant_Id
      )
      .subscribe((listeFinanceur) => {
        //listeFinanceur = this.generalService.generateListeFinanceur(listeFinanceur,this.listeModePaiement,this.listeTva,this.listeModeFacturation,this.listeDelaiReglement)
        this.listeFinanceurComponen.setDataSource(listeFinanceur);
        setTimeout(() => {
          this.exist = true;
          var listeRechercheComponens =
            this.listeFinanceurComponen.rechercheComponens.toArray();
          for (var i = 0; i < listeFinanceur.length; i++) {
            listeRechercheComponens[i].parentVal =
              listeFinanceur[i].Tiers_NomPublic;
          }
        }, 100);
      });
  }
  onChangeComposonRecherche(event) {
    this.listeFinanceurComponen.dataSource.data[event.index].Tiers_code =
      event.colonneToReturn;
  }
  async getFrmModaliterFormation(openFrm: boolean) {
    var url = 'ds/formdata?code=avtCursusApprenant';

    if (
      this.listeModaliterFormationComponen.row != undefined &&
      this.actionFrmModaliterFormation == 'modifierModaliterFormation'
    ) {
      url +=
        '&val=' +
        this.listeModaliterFormationComponen.row.avtCursusApprenant_Id;
    }
    this.exist = false;
    //chargement CursusApprenant
    this.initCursusApprenant = await this.generalService
      .rechercheTable(url)
      .toPromise();

    this.cursusApprenant = this.initCursusApprenant.avtCursusApprenant[0];
    if (this.cursusApprenant.avtCursusApprenant_Id != null)
      this.getListeFinanceur();
    this.cursusApprenant.Perso_Matricule = this.param_code;
    if (openFrm) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '90%';
      try {
        this.generalService.dialogOpend.close();
      } catch {}
      this.generalService.dialogOpend = this.dialog.open(
        this.frmModaliterFormation,
        dialogConfig
      );
    }
    this.exist = true;
  }
  blurFinanceur(event) {
    this.Tiers_codeFinanceur = event;
    // this.data.Perso_CodeFinencement = event;
  }
  ModifierFinanceur() {
    if (this.listeFinanceurComponen.row != undefined) {
      var financeur = this.listeFinanceurComponen.row;
      this.exist = false;
      this.generalService
        .rechercheTable(
          'ds/formdata?code=avtCursusFinance&val=' +
            financeur.avtCursusFinance_Id
        )
        .subscribe(
          (data) => {
            //var h = this.listeFinanceurComponen.rechercheComponens.toArray()[this.listeFinanceurComponen.rowIndex]
            data.avtCursusFinance[0].Tiers_code = financeur.Tiers_code;
            data.avtCursusFinance[0].avtCursusFinance_NbrHeure =
              financeur.avtCursusFinance_NbrHeure;
            data.avtCursusFinance[0].avtCursusFinance_ModeFacturation =
              financeur.avtCursusFinance_ModeFacturation;
            data.avtCursusFinance[0].avtCursusFinance_DelaiReglement =
              financeur.avtCursusFinance_DelaiReglement;
            data.avtCursusFinance[0].avtCursusFinance_ModePaiement =
              financeur.avtCursusFinance_ModePaiement;
            data.avtCursusFinance[0].avtCursusFinance_Tva =
              financeur.avtCursusFinance_Tva;
            this.generalService.enregisterTable(data).subscribe(
              (d) => {
                this.getListeFinanceur();
                this.generalService.dialogSuccess('Enregistré', true);
              },
              () => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
          },
          () => {
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
    }
  }
  supprimerFinanceur() {
    if (this.listeFinanceurComponen.row != undefined) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(
            this.listeFinanceurComponen.row.avtCursusFinance_Id,
            'avtCursusFinance'
          );
          if (deleteFn != null) {
            this.exist = false;
            deleteFn.subscribe(
              (data) => {
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.getListeFinanceur();
                this.exist = true;
              },
              (error) => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
              }
            );
          }
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  ajouterFinanceur() {
    if (
      this.listeFinanceurComponen.dataSource.data.find((f) => {
        return f.Tiers_code == this.Tiers_codeFinanceur;
      }) == undefined
    ) {
      this.exist = false;
      this.generalService
        .rechercheTable('ds/formdata?code=avtCursusFinance')
        .subscribe(
          (data) => {
            data.avtCursusFinance[0].avtCursusApprenant_Id =
              this.cursusApprenant.avtCursusApprenant_Id;
            data.avtCursusFinance[0].Tiers_code = this.Tiers_codeFinanceur;
            data.avtCursusFinance[0].avtCursusFinance_NbrHeure =
              this.avtCursusFinance.avtCursusFinance_NbrHeure;
            data.avtCursusFinance[0].avtCursusFinance_ModeFacturation =
              this.avtCursusFinance.avtCursusFinance_ModeFacturation;
            data.avtCursusFinance[0].avtCursusFinance_DelaiReglement =
              this.avtCursusFinance.avtCursusFinance_DelaiReglement;
            data.avtCursusFinance[0].avtCursusFinance_ModePaiement =
              this.avtCursusFinance.avtCursusFinance_ModePaiement;
            data.avtCursusFinance[0].avtCursusFinance_Tva =
              this.avtCursusFinance.avtCursusFinance_Tva;
            this.generalService.enregisterTable(data).subscribe(
              (d) => {
                this.getListeFinanceur();
                this.generalService.dialogSuccess('Enregistré', true);
              },
              () => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
          },
          () => {
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
    } else
      this.generalService.dialogSuccess(
        'Le financeure introduit existe déjà',
        false
      );
  }
  onTypePersoChange(value: string) {
    if (this.generalService.isNotEmpty(value)) {
      if (this.listeTypePersoIsLoadet) {
        var typeColl = this.listeTypePerso.find((typeC) => {
          return typeC.DiverSys_Index == value;
        });
        if (typeColl != undefined)
          if (this.generalService.isNotEmpty(typeColl.DiverSys_Libelle))
            if (typeColl.DiverSys_Libelle == '0')
              //collaborateur prestataire
              this.showPrestataire = true;
            else if (typeColl.DiverSys_Libelle == '1')
              this.showPrestataire = false;
      }
      //apprenant
      if (this.perso_Type == '2') {
        if (this.generalService.isNotEmpty(this.data.Tiers_code)) {
          this.generalService
            .rechercheTable(
              globalUrls.urlClient + '&val=' + this.data.Tiers_code
            )
            .subscribe((client) => {
              this.steApprenant = client.Tiers[0].Tiers_NomPublic;
            });
        }
        if (
          this.listeContratsIsLoadet &&
          this.listeTypeContratBrutIsLoadet &&
          this.listeTypeContratBrut.PersoContrat.length > 0
        )
          this.contrats = this.listeContrats.filter((contrat) => {
            return contrat.DiverSys_Group == value;
          });
      }
      //collaborateur
      else if (this.perso_Type == '0') {
        if (
          this.listeContratsIsLoadet &&
          this.listeTypeContratBrutIsLoadet &&
          this.listeTypeContratBrut.PersoContrat.length > 0
        )
          this.contrats = this.listeContrats.filter((contrat) => {
            return contrat.DiverSys_Group == this.data.Perso_TypePerso;
          });
        if (this.listeTempsIsLoadet && this.listeContratsIsLoadet)
          this.temps = this.listeTemps.filter((temp) => {
            return (
              temp.DiverSys_Group.toString() ==
                this.data.Perso_TypePerso.toString() &&
              temp.DiverSys_Libelle.toString() ==
                (this.data.Perso_ContratType
                  ? this.data.Perso_ContratType.toString()
                  : '')
            );
          });
        if (this.listeRemunerations)
          this.remunerations = this.listeRemunerations.filter((temp) => {
            return temp.DiverSys_Group == this.data.Perso_TypePerso;
          });
        if (this.listeStatutsIsLoadet)
          this.statuts = this.listeStatuts.filter((temp) => {
            return temp.DiverSys_Group == this.data.Perso_TypePerso;
          });
      }
    }
  }
  initVariable() {
    this.disabledEchanges = true;
    this.disabledMatetiels = true;
    this.index = 0;
    this.show = true;
    this.perso_Type = '0';
    this.typeCollText = 'COLLABORATEURS';
    this.test = false;
    this.disabled = false;
    this.postUrl = '...';
    this.url = globalUrls.urlPerso;
    this.urlCompetence = globalUrls.urlListCompetence;
    this.typeColIsSalarier = true;
    this.selected = '2';
    this.showDoc = false;
    this.testAvatar = true;
    this.componentForm = this.generalService.componentForm;
    this.compt = 12;
    this.exist = true;
    this.disabledSituationProfessionnelle = true;
    this.activerDocument = true;
    this.showPrestataire = false;
    this.haveImage = false;
    this.imageName = '';
    this.imageSrc = '';
    this.imageType = '';
    this.showTabAlert = false;
    this.avatarSrc = '../../assets/avatar.png';
  }

  getCollaborateur(
    code: string,
    setCompetence: boolean,
    setBarCargementToTrue: boolean
  ) {
    if (this.typeTrs == '1') {
      this.httpGet(this.url, setCompetence, setBarCargementToTrue);
    }
    if (this.typeTrs == '2' || this.typeTrs == '3') {
      this.disabledSituationProfessionnelle = false;
      this.disabledEchanges = false;
      this.disabledMatetiels = false;
      this.activerDocument = false;
      this.disabledModaliteFormation = false;
      this.httpGet(
        this.url + '&val=' + code,
        setCompetence,
        setBarCargementToTrue
      );
    }
    if (this.typeTrs == '3') {
      this.disabled = true;
    }
    // Angular Editor Supprimer
    // this.editorConfig.editable = !this.disabled
    // Angular Editor Supprimer
    // this.editorConfig.height = "50px";
  }
  public handleAddressChange(address, col) {
    for (var i = 0; i < address.address_components.length; i++) {
      var addressType = address.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        var val =
          address.address_components[i][this.componentForm[addressType]];
        if (val != '' && val != null && val != undefined)
          switch (addressType) {
            case 'postal_code':
              eval('this.data' + col + '.Perso_Poste' + col + ' = val;');
              break;
            case 'country':
              eval('this.data' + col + '.Perso_Pays' + col + ' = val;');
              break;
            case 'administrative_area_level_1':
              eval('this.data' + col + '.Perso_Region' + col + ' = val;');
              break;
            case 'locality':
              eval('this.data' + col + '.Perso_Ville' + col + ' = val');
              break;
            case 'route':
              eval('this.data' + col + '.Perso_Adresse2' + col + ' = val;');
              break;
          }
      }
    }
  }

  saveImageCollaborateur(Perso_Matricule: string) {
    this.numberFileToSave++;
    //il ya une image à enregister
    if (this.imageName != '' && this.imageSrc != '') {
      //ajout
      if (this.typeTrs == '1') {
        this.addFiles(
          this.generalService.initDoc,
          this.imageSrc,
          this.imageName,
          Perso_Matricule,
          'collaborateur',
          null,
          'crerFichier',
          'avatar',
          '',
          this.imageType
        );
      }
      //modification
      else {
        this.generalService
          .rechercheTable(
            globalUrls.urlFindDoc +
              Perso_Matricule +
              ',' +
              'collaborateur' +
              ',' +
              'avatar'
          )
          .subscribe((imageColl) => {
            //le collabaorateur à une encienne image à modifier => modifiction image
            if (imageColl.length > 0) {
              this.imageCollaborateur = imageColl[imageColl.length - 1];

              this.generalService
                .rechercheTable(
                  globalUrls.urlFiles +
                    '&val=' +
                    this.imageCollaborateur.File_Id
                )
                .subscribe((file) => {
                  file.Files[0].File_Text = this.imageName;
                  file.Files[0].File_Content = this.imageSrc;
                  file.Files[0].File_Autre = this.imageType;
                  this.generalService
                    .enregisterTable(file)
                    .subscribe((data) => {
                      this.numberFileToSave--;
                      this.showMsgEnressitrer();
                    });
                });
            }
            //le collaborateur n'a pas d'image => ajoute image
            else
              this.addFiles(
                this.generalService.initDoc,
                this.imageSrc,
                this.imageName,
                Perso_Matricule,
                'collaborateur',
                null,
                'crerFichier',
                'avatar',
                '',
                this.imageType
              );
          });
      }
    } else {
      this.numberFileToSave--;
      this.showMsgEnressitrer();
    }
  }
  onChangeImagefile(fileInput) {
    var reader2 = new FileReader();
    var src: string;
    this.haveImage = true;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      // var image = document.getElementById("imageDiv");
      //image.setAttribute("src",src);
      this.avatarSrc = src;
      this.imageName = fileInput.target.files[0].name;
      this.imageType = src.substring(0, src.indexOf(',') + 1);
      this.imageSrc = src.replace(this.imageType, '');
      if (this.typeTrs == '2' || this.typeTrs == '10') {
        this.exist = false;
        this.saveImageCollaborateur(this.param_code);
      }
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.initVariable();
      this.exist = false;
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      if (this.typeTrs == '3') {
        this.listBtnModaliterFormation.forEach((btn) => {
          btn.disabled = true;
        });
        this.listBtnMachine.forEach((btn) => {
          btn.disabled = true;
        });
        this.listBtnReservationMachine.forEach((btn) => {
          btn.disabled = true;
        });
      }
      this.perso_Type = params['typeColl'];
      this.setClassCardInformation();
      this.getCollaborateur(this.param_code, true, true);
      this.getListeReservationMachine();
      this.getListeMachine();
      this.getMachineMultimediaEtCarburantEtTypeSalle();
      this.showImage(this.param_code);
    });
  }
  listeReservationMachine = [];
  listeReservationMachineIsloadet: boolean = false;
  listeMachine = [];
  listeMultimedia;
  listeCarburent;
  listeIndustriels;
  listeBTP;
  listeMachineIsloadet: boolean = false;
  dataIsLoadet: boolean = false;
  getListeReservationMachine() {
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=avtReservationEquip&param=' + this.param_code
      )
      .subscribe((data) => {
        // this.listeReservationMachineComponen.setDataSource(data);
        this.listeReservationMachine = data;
        this.listeReservationMachineIsloadet = true;
        if (this.dataIsLoadet) {
          this.setDataSourc(this.listeReservationMachine, 'reservationMachine');
        }
      });
  }
  getListeMachine() {
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=PersoMachine&param=' + this.param_code
      )
      .subscribe((data) => {
        // this.listeMachineComponen.setDataSource(data);
        this.listeMachine = data;
        this.listeMachineIsloadet = true;
        if (this.dataIsLoadet) {
          this.setDataSourc(this.listeMachine, 'machine');
        }
      });
  }
  getMachineMultimediaEtCarburantEtTypeSalle() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MACH02')
      .subscribe((listeMultimedia) => {
        this.listeMultimedia = listeMultimedia;
        this.generalService
          .rechercheTable(globalUrls.urlParametre + '&val=MACH01')
          .subscribe((listeCarburent) => {
            this.listeCarburent = listeCarburent;
            this.generalService
              .rechercheTable(globalUrls.urlParametre + '&val=MACH03')
              .subscribe((listeIndustriels) => {
                this.listeIndustriels = listeIndustriels;
                this.generalService
                  .rechercheTable(globalUrls.urlParametre + '&val=MACH04')
                  .subscribe((listeBTP) => {
                    this.listeBTP = listeBTP;
                    this.dataIsLoadet = true;
                    if (this.listeMachineIsloadet)
                      this.setDataSourc(this.listeMachine, 'machine');
                    if (this.listeReservationMachineIsloadet)
                      this.setDataSourc(
                        this.listeReservationMachine,
                        'reservationMachine'
                      );
                  });
              });
          });
      });
  }
  setDataSourc(datasource, mode) {
    var liste = [];
    datasource.forEach((d) => {
      if (d.Machine_Type == 1) {
        var carburent = this.listeCarburent.DiverSys.find((c) => {
          return c.DiverSys_Index == d.Machine_CH;
        });
        if (carburent != undefined) carburent = carburent.DiverSys_Titre;
        liste.push({
          Machine_Code: d.Machine_Code,
          type: d.Machine_CapUnite,
          numSerie: d.Machine_Serie,
          detaile: carburent,
        });
      }
      if (d.Machine_Type == 2) {
        var multimedia = this.listeMultimedia.DiverSys.find((c) => {
          return c.DiverSys_Index == d.Machine_CH;
        });
        if (multimedia != undefined) multimedia = multimedia.DiverSys_Titre;
        var type1 = '';
        var type = this.generalService.typeSalle.find((c) => {
          return c.DiverSys_Index == d.Machine_Compteur;
        });
        if (type != undefined) type1 = type.DiverSys_Titre;
        liste.push({
          Machine_Code: d.Machine_Code,
          type: multimedia,
          numSerie: d.Machine_Serie,
          detaile: type1,
        });
      }
      if (d.Machine_Type == 3) {
        var industriels = this.listeIndustriels.DiverSys.find((c) => {
          return c.DiverSys_Index == d.Machine_CH;
        });
        if (industriels != undefined) industriels = industriels.DiverSys_Titre;
        var type = this.generalService.typeSalle.find((c) => {
          return c.DiverSys_Index == d.Machine_Compteur;
        });
        var type1 = '';
        if (type != undefined) type1 = type.DiverSys_Titre;
        liste.push({
          Machine_Code: d.Machine_Code,
          type: industriels,
          numSerie: d.Machine_Serie,
          detaile: type1,
        });
      }
      if (d.Machine_Type == 4) {
        var btp = this.listeBTP.DiverSys.find((c) => {
          return c.DiverSys_Index == d.Machine_CH;
        });
        if (btp != undefined) btp = btp.DiverSys_Titre;
        var type = this.generalService.typeSalle.find((c) => {
          return c.DiverSys_Index == d.Machine_Compteur;
        });
        var type1 = '';
        if (type != undefined) type1 = type.DiverSys_Titre;
        liste.push({
          Machine_Code: d.Machine_Code,
          type: btp,
          numSerie: d.Machine_Serie,
          detaile: type1,
        });
      }
    });
    if (mode == 'reservationMachine') {
      if (this.listeReservationMachineComponen)
        this.listeReservationMachineComponen.setDataSource(liste);
    }
    if (mode == 'machine') {
      if (this.listeMachineComponen)
        this.listeMachineComponen.setDataSource(liste);
    }
  }
  setClassCardInformation() {
    //apprenant
    if (this.perso_Type == '2')
      this.classCardInformation = 'cardInformationApprenant';
    else this.classCardInformation = 'cardInformation';
  }

  httpGet(url, setCompetence: boolean, setBarCargementToTrue: boolean) {
    this.generalService.rechercheTable(url).subscribe(
      (data) => {
        if (setBarCargementToTrue) this.exist = true;
        this.ds = data;
        if (this.typeTrs == '2')
          this.dsCompetance = this.generalService.clone(this.ds.PersoComp);
        this.data = data.perso[0];
        this.getInitData(setCompetence);
      },
      (error) => {}
    );
  }
  getInitData(setCompetence) {
    if (
      this.data.Perso_Civilite == '' ||
      this.data.Perso_Civilite == null ||
      this.data.Perso_Civilite == undefined
    )
      this.data.Perso_Civilite = 'Monsieur';

    this.data.Perso_Type = this.perso_Type;
    if (this.typeTrs == '1') {
      this.data.Perso_Statut = '0';
      this.data.Perso_CFP = '0';
      this.data.Perso_NumSecu = '';
    }
    if (setCompetence) this.setCompetence();

    //condidat
    if (this.perso_Type == '1') {
      this.typeCollText = 'CANDIDATS';
      this.show = false;
      if (this.typeTrs == '2' || this.typeTrs == '3') {
        this.showTabEchange = true;
        this.showTabAlert = true;
      }
      this.getTypePerso('COL13');
    }
    //apperant
    else if (this.perso_Type == '2') {
      this.typeCollText = 'APPRENANTS';
      //pour defini les champs obligatoire si date naissance < 18
      if (!this.isEmpty(this.data.Perso_DateNaissance)) {
        this.dateCollChange();
      }
      this.getParamTypeContart(this.data.Perso_Type);
      this.getModaliterFormation();
      this.getTypeContart('COL10');
      this.getTypePerso('COL07');
      this.getCursus();
      this.getListeTva();
      this.getListeModePaiement();
      this.getListeModeFacturation();
      this.getListeDelaiReglement();
    }
    // collaborateur
    else if (this.perso_Type == '0') {
      this.typeCollText = 'COLLABORATEURS';
      this.getParamTypeContart(this.data.Perso_Type);
      this.getTomps();
      this.getRemuneration();
      this.getListeStatuts();
      this.getTypeContart('COL04');
      this.getTypePerso('COL01');
      this.getTypeFonction();
      this.getUniteDurer();
    }
  }
  getListeCursusApprenant() {
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=avtCursusApprenant&param=' + this.param_code
      )
      .subscribe((cursus) => {
        this.generateListeCursusApprenant(cursus);
      });
  }
  generateListeCursusApprenant(listeCursus) {
    listeCursus.forEach((cursu) => {
      //type apprenant
      var typeApp = this.listeTypePerso.find((type) => {
        return type.DiverSys_Index == cursu.avtCursusApprenant_TypeApp;
      });
      if (typeApp != undefined) typeApp = typeApp.DiverSys_Titre;
      cursu['TypeApp'] = typeApp;
      //type contrat
      var typeContrat = this.listeContrats.find((type) => {
        return type.DiverSys_Index == cursu.avtCursusApprenant_TypeContrat;
      });
      if (typeContrat != undefined) typeContrat = typeContrat.DiverSys_Titre;
      cursu['TypeContrat'] = typeContrat;
      //modaliter
      var typeModaliter = this.listeModaliterApprenant.find((type) => {
        return type.DiverSys_Index == cursu.avtCursusApprenant_Mododalite;
      });
      if (typeModaliter != undefined)
        typeModaliter = typeModaliter.DiverSys_Titre;
      cursu['Mododalite'] = typeModaliter;
      //cursus
      var cursus = this.listeCursus.find((type) => {
        return type.Cursus_Code == cursu.Cursus_Code;
      });
      if (cursus != undefined) cursus = cursus.Cursus_Titre;
      cursu['Cursus'] = cursus;
      //nature
      var nature = this.listeNature.find((n) => {
        return n.value == cursu.avtCursusApprenant_Nature;
      });
      cursu['Perso_Nature'] = nature.text;
    });
    this.listeCursusApprenant = listeCursus;
    this.listeModaliterFormationComponen.setDataSource(
      this.listeCursusApprenant
    );
  }

  onSelectionCompetence(liste) {
    liste.forEach((element) => {
      var existeComp = this.ds.PersoComp.find((c) => {
        return c.GRHComp_Code == element.value;
      });
      if (existeComp == undefined) {
        var comp = this.dataCompetence.find((c) => {
          return c.DiverSys_Index == element.value;
        });
        if (comp != undefined) {
          this.ds.PersoComp.push({
            GRHComp_Code: element.value,
            GRHComp_Libelle: comp.DiverSys_Titre,
            PersoComp_Score: 0,
            Perso_Matricule: this.data.Perso_Matricule,
            U_timestamp: null,
          });
        }
      }
    });
  }

  enregistrerInitDoc(idColl) {
    this.generalService
      .rechercheTable(globalUrls.urlListeDocument)
      .subscribe((lstDoc) => {
        this.docCollBrut = this.generalService.generateTreeData(lstDoc);
        for (var i = 0; i < this.docCollBrut.length; i++) {
          this.numberFileToSave++;
          this.addFiles(
            this.generalService.initDoc,
            '',
            this.docCollBrut[i].text,
            idColl,
            'collaborateur',
            this.docCollBrut[i].parent,
            'crerDossier',
            this.docCollBrut[i].id,
            '',
            ''
          );
        }
        this.activerDocument = false;
      });
  }
  sexeChange(event) {
    if (this.data.Perso_Civilite == 'Monsieur') {
      $('#PrefixSexe').text('1');
      //this.data.Perso_NumSecu = "1"+ this.data.Perso_NumSecu.substring(1,this.data.Perso_NumSecu.length);
    } else {
      $('#PrefixSexe').text('2');
      //this.data.Perso_NumSecu = "2"+ this.data.Perso_NumSecu.substring(1,this.data.Perso_NumSecu.length);
    }
  }
  showMsgEnressitrer() {
    if (this.numberFileToSave == 0) {
      this.generalService.dialogSuccess('Enregistré', true);
      this.exist = true;
    }
  }
  removeTextFromNumber() {
    setTimeout(() => {
      this.data.Perso_NumSecu = this.generalService.removeTextFromNumber(
        this.data.Perso_NumSecu
      );
    }, 1);
  }
  removeTextFromNumber2(event) {
    event.currentTarget.value = this.generalService.removeTextFromNumber(
      event.currentTarget.value
    );
  }
  supprimerCompetenceEliminer() {
    var competanceTodelete = [];
    var compte = 0;
    competanceTodelete = this.dsCompetance.filter((competance) => {
      return (
        this.generalService.isNotEmpty(competance.GRHComp_Code) &&
        this.listeCompetences.selectedOptions.selected.find((comp) => {
          return comp.value == competance.GRHComp_Code;
        }) == undefined
      );
    });
    if (competanceTodelete.length > 0)
      competanceTodelete.forEach((competance) => {
        this.generalService
          .supprimerSanMsgConfirm(competance.GRHComp_Code, 'PersoComp')
          .subscribe(() => {
            compte++;
            if (compte == competanceTodelete.length)
              this.getCollaborateur(this.param_code, false, false);
          });
      });
    else this.getCollaborateur(this.param_code, false, false);
  }
  enregister() {
    //@ViewChild//
    this.tabGroupe._tabs.toArray[this.index];
    if (
      this.tabGroupe._tabs.toArray()[this.index].textLabel ==
        this.informations &&
      !this.formInformation.form.valid
    ) {
      $('#btnFormInformation').trigger('click');
      this.generalService.dialogSuccess(
        'veuillez saisir les champs marqués en rouge',
        false
      );
      return;
    }
    if (
      this.tabGroupe._tabs.toArray()[this.index].textLabel ==
        this.modaliterFormation &&
      !this.formModaliteFormation.form.valid
    ) {
      $('#btnformModaliteFormation').trigger('click');
      this.generalService.dialogSuccess(
        'veuillez saisir les champs marqués en rouge',
        false
      );
      return;
    }
    if (
      this.tabGroupe._tabs.toArray()[this.index].textLabel ==
        this.situationPro &&
      !this.formSituationProfessionnelle.form.valid
    ) {
      $('#btnSituationProfessionnelle').trigger('click');
      this.generalService.dialogSuccess(
        'veuillez saisir les champs marqués en rouge',
        false
      );
      return;
    }
    this.exist = false;
    this.generalService
      .rechercheTable(globalUrls.urlListPerso + this.perso_Type)
      .subscribe((listeColl) => {
        var findCol = listeColl.find((coll) => {
          return (
            coll.Perso_Nom == this.data.Perso_Nom &&
            coll.Perso_Prenom == this.data.Perso_Prenom &&
            coll.Perso_DateNaissance == this.data.Perso_DateNaissance &&
            coll.Perso_Matricule != this.data.Perso_Matricule
          );
        });
        if (!findCol) {
          this.save();
        } else {
          this.generalService.dialogSuccess(
            'Ce ' + this.typeCollText.toLowerCase() + ' existe déjà',
            false
          );
          this.exist = true;
        }
      });
  }
  save() {
    this.generalService
      .enregisterTable(
        this.generalService.supprimerTableVideAction(
          this.ds,
          ['PersoComp'],
          'Perso_Matricule'
        )
      )
      .subscribe(
        (data) => {
          if (this.typeTrs == '1') {
            this.param_code = data.code;
            this.showCompte = true;
            this.enregistrerInitDoc(data.code);
            this.saveImageCollaborateur(data.code);
          }
          this.showMsgEnressitrer();
          this.typeTrs = '2';
          this.supprimerCompetenceEliminer();
          // this.generalService.dialogSuccess("Enregisté",true);
        },
        (err: HttpErrorResponse) => {
          this.generalService.dialogSuccess('Non enregisté', false);
          this.exist = true;
        }
      );
  }
  isEmpty(txt: string): boolean {
    if (txt == '' || txt == null || txt == undefined) return true;
    else return false;
  }

  setCompetence() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MAT01')
      .subscribe(
        (data) => {
          this.dataCompetence = this.generalService.sort(
            data.DiverSys,
            'DiverSys_Titre'
          );
          this.setCompetenceColl();
        },
        (error) => {}
      );

    //
  }
  setCompetenceColl() {
    this.ds.PersoComp.forEach((comp) => {
      this.dataCompetence.forEach((c) => {
        if (c.DiverSys_Index == comp.GRHComp_Code) c.selected = 'selected';
      });
    });
    this.showCompetenceColl = true;
  }

  showImage(code) {
    if (this.typeTrs != '1')
      this.generalService
        .rechercheTable(
          globalUrls.urlFindDoc + code + ',' + 'collaborateur' + ',' + 'avatar'
        )
        .subscribe(
          (data) => {
            const b64Data = data;
            if (b64Data != undefined && b64Data != null && b64Data.length > 0) {
              this.haveImage = true;
              this.avatarSrc =
                b64Data[b64Data.length - 1].File_Autre +
                b64Data[b64Data.length - 1].File_Content;
              this.imageCollaborateur = b64Data[b64Data.length - 1];
            } else this.haveImage = false;
          },
          (err) => {}
        );
    else this.avatarSrc = '../../assets/avatar.png';
  }
  onNationaliteChange(e) {
    var list = this.generalService.nationalitePays.filter((val) => {
      return (
        val.nationalite.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = this.generalService.nationalitePays;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    this.nationalite = list;
  }
  onPaysChange(e) {
    var list = this.generalService.nationalitePays.filter((val) => {
      return (
        val.libelle.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
      );
    });
    if (list.length == 0) {
      list = this.generalService.nationalitePays;
      e.target.value = e.target.value.substr(0, e.target.value.length - 1);
    }
    this.pays = list;
  }
  setOldIndex() {
    this.oldIndex = this.index;
  }
  tabChanged(event) {
    this.showEditerContrat = false;
    if (
      this.tabGroupe._tabs.toArray()[this.index].textLabel == this.situationPro
    ) {
      this.showEditerContrat = true;
    }
    if (event.index > this.oldIndex && !this.disabled) {
      if (
        this.tabGroupe._tabs.toArray()[this.oldIndex].textLabel ==
          this.informations &&
        !this.formInformation.form.valid
      ) {
        $('#btnFormInformation').trigger('click');
        this.index = this.generalService.clone(this.oldIndex);
        return;
      }
      if (
        this.tabGroupe._tabs.toArray()[this.oldIndex].textLabel ==
          this.modaliterFormation &&
        !this.formModaliteFormation.form.valid
      ) {
        $('#btnModaliteFormation').trigger('click');
        this.index = this.generalService.clone(this.oldIndex);
        return;
      }
      if (
        this.tabGroupe._tabs.toArray()[this.oldIndex].textLabel ==
          this.situationPro &&
        !this.formSituationProfessionnelle.form.valid
      ) {
        $('#btnSituationProfessionnelle').trigger('click');
        this.index = this.generalService.clone(this.oldIndex);
        return;
      }
      if (this.index < 3) this.enregister();
    }

    if (this.tabGroupe._tabs.toArray()[event.index].textLabel == this.document)
      this.showDoc = true;
    //@ViewChild//
  }
  selectImage() {
    if (!this.disabled) document.getElementById('imageFile').click();
  }
  onContratChange() {
    if (this.listeTempsIsLoadet && this.listeContratsIsLoadet)
      this.temps = this.listeTemps.filter((temp) => {
        return (
          temp.DiverSys_Group.toString() ==
            this.data.Perso_TypePerso.toString() &&
          temp.DiverSys_Libelle.toString() ==
            this.data.Perso_ContratType.toString()
        );
      });
    if (this.listeTypeContratBrutIsLoadet) {
      this.showHideDateFinContrat();
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien,
    File_Autre
  ) {
    var id;
    var doc = this.generalService.clone(initDoc);
    doc.files[0].File_Parent = File_Parent;
    doc.files[0].File_Content = File_Content;
    doc.files[0].File_Text = File_Text;
    doc.files[0].File_Key = File_Key;
    doc.files[0].File_Type = File_Type;
    doc.files[0].File_Groupe = File_Groupe;
    doc.files[0].File_Lien = File_Lien;
    doc.files[0].File_Autre = File_Autre;
    if (clickMode == 'crerFichier') {
      doc.files[0].File_Dll = 'jstree-file';
    }
    if (clickMode == 'crerDossier') {
      doc.files[0].File_Dll = 'jstree-folder';
    }
    this.generalService.enregisterTable(doc).subscribe((data) => {
      this.numberFileToSave--;
      this.showMsgEnressitrer();
    });
    return id;
  }
  telechargerContart() {
    window.open(this.generalService.urlContratDocx + this.param_code, '_top');
  }
  removeNumberFromText(text: string, attribut: string) {
    setTimeout(() => {
      var myText = this.generalService.removeNumberFromText(text);
      var data = this.data;
      eval('data.' + attribut + ' = myText');
    }, 1);
  }
  dateCollChange() {
    if (this.perso_Type == '2') {
      var today = new Date();
      var birthDate = new Date(this.data.Perso_DateNaissance);
      var age = this.dateService.yearDiff(birthDate, new Date());
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age < 18) this.apprenantNotMineur = false;
      else this.apprenantNotMineur = true;
    }
  }
  getTypeFonction() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL06')
      .subscribe((data) => {
        this.listeTypeFontion = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  getTypePerso(code) {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + code)
      .subscribe((data) => {
        this.listeTypePerso = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeTypePersoIsLoadet = true;
        if (
          this.listeModaliterApprenantIsLoadet &&
          this.listeTypeContratBrutIsLoadet &&
          this.listeContratsIsLoadet &&
          this.listeCursusIsLoadet
        ) {
          this.getListeCursusApprenant();
        }
        this.onTypePersoChange(this.data.Perso_TypePerso);
      });
  }
  getTypeContart(code) {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + code)
      .subscribe((data) => {
        data = this.generalService.sort(data.DiverSys, 'DiverSys_Titre');
        this.listeContrats = data;
        this.listeContratsIsLoadet = true;
        this.onTypePersoChange(this.data.Perso_TypePerso);
        if (
          this.listeModaliterApprenantIsLoadet &&
          this.listeTypeContratBrutIsLoadet &&
          this.listeTypePersoIsLoadet &&
          this.listeCursusIsLoadet
        ) {
          this.getListeCursusApprenant();
        }
      });
  }
  getParamTypeContart(Perso_Type) {
    this.generalService
      .rechercheTable(globalUrls.urlpersocontrat + '&val=' + Perso_Type)
      .subscribe((data) => {
        this.listeTypeContratBrut = data;
        this.listeTypeContratBrutIsLoadet = true;
        if (
          this.listeModaliterApprenantIsLoadet &&
          this.listeContratsIsLoadet &&
          this.listeTypePersoIsLoadet &&
          this.listeCursusIsLoadet
        ) {
          this.getListeCursusApprenant();
        }
        this.onTypePersoChange(this.data.Perso_TypePerso);
        this.showHideDateFinContrat();
      });
  }
  // afficher ou masquer Date Fin Contrat
  showHideDateFinContrat() {
    var contrat = this.listeTypeContratBrut.PersoContrat.find((c) => {
      return c.PersoContrat_Type == this.data.Perso_ContratType;
    });
    if (contrat != undefined) {
      if (contrat.PersoContrat_Fin == 1) this.showDateFinContrat = true;
      if (contrat.PersoContrat_Fin == 0) this.showDateFinContrat = false;
    }
  }
  getUniteDurer() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL09')
      .subscribe((data) => {
        this.uniteDurer = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  ajouterCompte(f) {
    if (f.form.valid) {
      if (this.user.confirmpassword == this.user.password) {
        this.disabledBtnCpmpte = true;
        this.exist = false;
        this.generalService.enregisterCompte(this.user).subscribe(
          (data) => {
            this.generalService.dialogSuccess('Eenregistré', true);
            this.exist = true;
          },
          (err) => {
            this.disabledBtnCpmpte = false;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
      } else
        this.generalService.dialogSuccess(
          'Les mots de passe tapés ne sont pas identiques',
          false
        );
    }
  }
  getTomps() {
    var url = globalUrls.urlParametre + '&val=COL05';
    //apprenant
    if (this.perso_Type == '2') url = globalUrls.urlParametre + '&val=COL14';
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.listeTemps = this.generalService.sort(
        data.DiverSys,
        'DiverSys_Titre'
      );
      this.listeTempsIsLoadet = true;
      this.onTypePersoChange(this.data.Perso_TypePerso);
    });
  }
  getListeStatuts() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL03')
      .subscribe((data) => {
        this.listeStatuts = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeStatutsIsLoadet = true;
        this.onTypePersoChange(this.data.Perso_TypePerso);
      });
  }
  getRemuneration() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL08')
      .subscribe((data) => {
        this.listeRemunerations = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeRemunerationsIsLoated = true;
        this.onTypePersoChange(this.data.Perso_TypePerso);
      });
  }
  getModaliterFormation() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL12')
      .subscribe((data) => {
        this.listeModaliterApprenant = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeModaliterApprenantIsLoadet = true;
        if (
          this.listeTypeContratBrutIsLoadet &&
          this.listeContratsIsLoadet &&
          this.listeTypePersoIsLoadet &&
          this.listeCursusIsLoadet
        ) {
          this.getListeCursusApprenant();
        }
      });
  }
  dateCursusApprenant_DebCollChange() {
    if (
      !this.generalService.isNotEmpty(
        this.cursusApprenant.avtCursusApprenant_Fin
      )
    ) {
      this.cursusApprenant.avtCursusApprenant_Fin = new Date(
        this.cursusApprenant.avtCursusApprenant_Deb
      );
    }
  }
  getCursus() {
    this.generalService
      .rechercheTable(globalUrls.urlListeApplyCursus)
      .subscribe((data) => {
        this.listeCursus = this.generalService.sort(data, 'Cursus_Titre');
        this.listeCursusIsLoadet = true;
        if (
          this.listeTypeContratBrutIsLoadet &&
          this.listeContratsIsLoadet &&
          this.listeTypePersoIsLoadet &&
          this.listeModaliterApprenantIsLoadet
        ) {
          this.getListeCursusApprenant();
        }
      });
  }
  getListeTva() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM01')
      .subscribe((data) => {
        data = this.generalService.sort(data.DiverSys, 'DiverSys_Titre');
        this.listeTva = data;
        this.columnsFinanceur.TableRD[4].dataSelect = data;
        this.listeTvaIsLoadet = true;
      });
  }
  getListeModePaiement() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM04')
      .subscribe((data) => {
        data = this.generalService.sort(data.DiverSys, 'DiverSys_Titre');
        this.listeModePaiement = data;
        this.columnsFinanceur.TableRD[3].dataSelect = data;
        this.listeModePaiementIsLoadet = true;
      });
  }
  getListeModeFacturation() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM02')
      .subscribe((data) => {
        data = this.generalService.sort(data.DiverSys, 'DiverSys_Titre');
        this.listeModeFacturation = data;
        this.columnsFinanceur.TableRD[5].dataSelect = data;
        this.listeModeFacturationIsLoadet = true;
      });
  }
  getListeDelaiReglement() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM03')
      .subscribe((data) => {
        data = this.generalService.sort(data.DiverSys, 'DiverSys_Titre');
        this.listeDelaiReglement = data;
        this.columnsFinanceur.TableRD[6].dataSelect = data;
        this.listeDelaiReglementIsLoadet = true;
      });
  }

  retourListes() {
    this.generalService.popupCenter(
      '/w/avt/parametre/liste/collaborateurs/' + this.perso_Type
    );
    // this.generalService.paramListeColl = this.perso_Type;
    // this.generalService.dialogOpend = this.generalService.dialog.open(ListeCollaborateursComponent, new MatDialogConfig());
    // this.exist = false;
    // this.generalService.dialogOpend.afterClosed().subscribe(() =>
    // {
    //   if( this.generalService.isNotEmpty( this.generalService.documentChoisie))
    //   {
    //     this.param_code = (this.generalService.documentChoisie.Perso_Matricule);
    //     this.typeTrs = "2";
    //     this.getCollaborateur(this.param_code,true,true);
    //     this.showImage(this.param_code);
    //   }
    //   this.exist = true;
    // });
    // this.router.navigate(['avt/parametre/liste/clients/'+this.typeClient]);
  }
}
